// section — wireframe skin module
// Token disposition: color tokens overridden to wf-* namespace; spacing/sizing pass-through

export const styles = `
  :host {
    display: block;
  }
`;

export function render(host) {
  const { heading, level, divider } = host;
  const safeHeading = heading.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  host.shadowRoot.innerHTML = `
    <run-box>
      <run-stack>
        <run-text id="section-heading" variant="heading" as="h${level}">${safeHeading}</run-text>
        ${divider ? `<run-divider aria-hidden="true"></run-divider>` : ''}
        <slot></slot>
      </run-stack>
    </run-box>
  `;
}